import { FC } from "react";

import { Tag, TagKind, TagSize } from "@livechat/design-system-react-components";

import { TicketStatus, TicketStatusFormattedValues } from "interfaces/entities/ticket";

interface IProps {
  status: TicketStatus;
  size?: TagSize;
}

const ticketStatusToTagKindMap: {
  [key in TicketStatus]: Extract<TagKind, "default" | "info" | "purple" | "black" | "success">;
} = {
  [TicketStatus.Open]: "info",
  [TicketStatus.Pending]: "default",
  [TicketStatus.OnHold]: "purple",
  [TicketStatus.Solved]: "success",
  [TicketStatus.Closed]: "black",
  // @ts-expect-error TS(2339): Property 'Spam' does not exist on type 'typeof Tic... Remove this comment to see the full error message
  [TicketStatus.Spam]: "default",
};

export const StatusTag: FC<IProps> = ({ status, size = "small" }) => {
  const tagColor = ticketStatusToTagKindMap[status];

  return (
    <Tag size={size} kind={tagColor} data-testid={`status-tag-${status}`}>
      {TicketStatusFormattedValues[status]}
    </Tag>
  );
};
